import { getInitials } from "@/lib/string";
import { twMerge } from "tailwind-merge";

interface PatientAvatarProps {
  fullName: string;
  className?: string;
}

export function PatientAvatar({ fullName, className }: PatientAvatarProps) {
  return (
    <div
      className={twMerge(
        "flex size-[48px] shrink-0 items-center justify-center rounded-full bg-[#111827] text-[15px] font-extrabold tracking-[0.02em] text-white",
        className,
      )}
    >
      {getInitials(fullName)}
    </div>
  );
}
